import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import CountUp from 'react-countup';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { enhanceComponent } from '@legacyApp/client/wrappers/enhanceComponent';
import { AwesomeIcon } from '@common/components/icons/AwesomeIcon';
import { isTrueOrZero } from '@common/methods/isTrueOrZero';
import { checkHotkeysAllowed } from '@legacyApp/client/modules/app/checkHotkeysAllowed';
import { roundNumber } from '@common/methods/roundNumber/roundNumber';
import { StyledLimboCounter } from './LimboCounter.styled';

class LimboCounter extends React.PureComponent {
	static propTypes = {
		result: PropTypes.any,
		target: PropTypes.any,
		animation: PropTypes.bool,
		set: PropTypes.func,
		small: PropTypes.bool,
		hotkeys: PropTypes.bool,
		className: PropTypes.any,
		updateTarget: PropTypes.func,
		getHotkey: PropTypes.func,
		disableHotkeys: PropTypes.bool,
		screenWidth: PropTypes.number,
	};

	constructor(props) {
		super(props);
		this.state = {
			className: '',
		};
		this.timeout = null;
		this.el = React.createRef();
	}

	componentDidMount() {
		if (this.props.hotkeys) {
			window.addEventListener('keydown', this.handleKeyboard);
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.result !== prevProps.result) {
			this.onStart();
		}
	}

	componentWillUnmount() {
		if (this.props.hotkeys) {
			window.removeEventListener('keydown', this.handleKeyboard);
		}
		if (this.timeout) {
			clearTimeout(this.timeout);
		}
		if (this.props.set) {
			this.props.set(false);
		}
	}

	handleKeyboard = (obj) => {
		if (!this.el || !checkHotkeysAllowed(this.props.disableHotkeys)) {
			return;
		}

		if (obj.keyCode === this.props.getHotkey('lower_target', 'limbo').keyCode) {
			obj.preventDefault();
			this.props.updateTarget(
				roundNumber(parseFloat(this.props.target) - 1, 0),
			);
		}

		if (
			obj.keyCode === this.props.getHotkey('higher_target', 'limbo').keyCode
		) {
			obj.preventDefault();
			this.props.updateTarget(
				roundNumber(parseFloat(this.props.target) + 1, 0),
			);
		}
	};

	onEnd = () => {
		if (!this.props.result) {
			return;
		}
		this.setState({
			className: this.props.target
				? parseFloat(this.props.result) >= parseFloat(this.props.target)
					? 'text-positive'
					: 'text-negative'
				: '',
		});
	};

	onStart = () => {
		if (!this.props.animation) {
			return this.onEnd();
		}
		this.setState({
			className: '',
		});
		if (this.props.result) {
			this.timeout = setTimeout(() => this.onEnd(), 400);
		}
	};

	render() {
		const result = parseFloat(this.props.result || 1);
		return (
			<StyledLimboCounter
				$length={`${result.toFixed(2) || ''}`.length}
				$screenWidth={this.props.screenWidth}
				$noTarget={!isTrueOrZero(this.props.target) || this.props.small}
				ref={this.el}
				className={classnames(
					this.state.className,
					this.props.className,
					'text-style-md-semibold',
				)}
			>
				{this.props.animation ? (
					<CountUp
						end={result}
						start={1}
						duration={0.5}
						decimals={2}
						separator={' '}
					/>
				) : (
					<span>{result.toFixed(2)}</span>
				)}
				<AwesomeIcon icon={faTimes} />
			</StyledLimboCounter>
		);
	}
}

LimboCounter = enhanceComponent({
	LimboCounter,
});

export default LimboCounter;
